import Check from "../components/Check";
import Header from "../components/Header";
import { rootReducer } from "../store/store";
import "./scss/reservation.scss";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import SvgIcon from "@mui/material/SvgIcon";
import DoDisturbOnOutlinedIcon from "@mui/icons-material/DoDisturbOnOutlined";
import PauseCircleOutlinedIcon from "@mui/icons-material/PauseCircleOutlined";
import { ko } from "date-fns/locale";
import InsuranceModal from "../components/InsuranceModal";
import { CarInsuranceChargeInfo } from "../types/CarInsuranceChargeTypes";
import { AdditionRestChargeInfo } from "../types/AdditionRestChargeTypes";
import ProductModal from "../components/ProductModal";
import AlertModal from "../components/AlertModal";
import { driver, totalPrice, memberRegFlag } from "../actions/authActions";
import { Driver } from "../types/DriverTypes";
import { ConfirmType, confirmType } from "../types/CommonType";
import ConfirmModal from "../components/ConfirmModal";
import InsuranceJoinModal from "../components/InsuranceJoinModal";
import { useCommonUtil } from "../util/useCommonUtil";

type AuthState = ReturnType<typeof rootReducer>;

const Reservation: React.FC = () => {
  const history = useHistory();
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [modalContent, setModalContent] = useState<string>("");
  const [argeeCheck, setArgreeCheck] = useState<boolean>(false);
  const [insDetail, setInsDetail] = useState<CarInsuranceChargeInfo>();
  const [prodDetail, setProdDetail] = useState<AdditionRestChargeInfo[]>();
  const [detailShow, setDetailShow] = useState<boolean>(false);
  const [productDetailShow, setProductDetailShow] = useState<boolean>(false);
  const [insJoinShow, setInsJoinShow] = useState<boolean>(false);
  const [confirmInfo, setConfirmInfo] = useState<ConfirmType>(confirmType)
  const [totalAmt, setTotalAmt] = useState<number>(0);
  const [addProductAmt, setAddProductAmt] = useState<number>(0)
  const [addInsSubAmt, setAddInsSubAmt] = useState<number>(0)
  const [optionalArgeeCheck, setOptionalArgreeCheck] = useState<boolean>(false);
  const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);
  const driverPrev = useSelector((state: AuthState) => state.store.driver);

  const { formatBirthTime } = useCommonUtil();
  console.log('driverPrev ', driverPrev)
  const dispatch = useDispatch();
  const data = resInfo && resInfo.data;

  const ins =
    data?.carInsuranceChargeInfo?.filter(
      (e) => e.carInsuranceInfo.insuranceType !== "4000"
    ) ?? [];

  const insSub =
    data?.carInsuranceChargeInfo?.filter(
      (e) => e.carInsuranceInfo.insuranceType === "4000"
    ) ?? [];

  console.log('sub,', insSub)

  const formatTime = (milliseconds: number): string => {
    const date = new Date(milliseconds);
    const formattedTime = format(date, "MM/dd(EEE) HH:mm", { locale: ko });

    return formattedTime;
  }

  const formatNumber = (value: number): string => {
    const formattedValue = value.toLocaleString("ko-KR");
    return formattedValue;
  };

  const detailModal = (ins: CarInsuranceChargeInfo) => {
    setInsDetail(ins);
    setDetailShow(true);
  };

  const productDetail = (product: AdditionRestChargeInfo[]) => {
    setProdDetail(product);
    setProductDetailShow(true);
  };

  const calculateTimeDifference = (time1: Number, time2: Number) => {
    // 두 시간 사이의 밀리초 차이 계산
    const timeDiff = Math.abs(Number(time2) - Number(time1));

    // 밀리초를 시간과 분으로 변환
    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

    // 결과 반환
    return `${hours}시간 ${minutes}분`;
  }

  const nextStep = () => {

    if(optionalArgeeCheck === undefined || optionalArgeeCheck === null) setOptionalArgreeCheck(!optionalArgeeCheck);

    dispatch(memberRegFlag(optionalArgeeCheck));

    dispatch(
      totalPrice(
        (totalAmt - ((data?.accountInRequester || 0) - (data?.accountOutRequester || 0))) || 0
      )
    )
      ;
    if (!argeeCheck) {
      setModalTitle("유의사항 동의에 체크해주세요.");
      setModalContent(
        "유의사항 확인 후 체크해주세요.<br/> 동의해야 다음 단계 진행이 가능합니다."
      );
      setModalShow(true);
    } else {
      // if (ins && ins.length === 0) {
      //   setConfirmInfo({
      //     isOpen: true,
      //     title: '자차 미가입 상태',
      //     content: '현재 자차 보험 가입이 되어 있지 않습니다.</br> 자차미가입시 <span style=color:red;font-weight:600;>차량 사고비용 전액과 휴차보상료가 발생합니다.<span>'
      //   })
      //   return false
      // }

      if (resInfo?.data.preRegStatus === "Y") {
        let driverArr: Driver[] = [];

        driverArr.push({
          driverName: resInfo?.data.driver1stName,
          tel: resInfo?.data.driver1stTel,
          birthday: formatBirthTime(Number(resInfo?.data.driver1stBirthday)),
          licenseNum: resInfo?.data.driver1stLicenseNum || "",
          licenseType: resInfo?.data.driver1stLicenseType,
          fileId: resInfo?.data.driver1stLicenseImage,
          licenseFileGroupId: resInfo?.data.driver1stFileGroupId,
          emContactNumber: resInfo?.data.emergencyTel,
          licenseCerti: true,
          driverDirect: true,
          needCheckCareer: [],
          memberRegFlag: optionalArgeeCheck || false
        });

        if (resInfo?.data.driver2stName) {
          // dispatch(driver(driverArr));
          driverArr.push({
            driverName: resInfo?.data.driver2stName,
            tel: resInfo?.data.driver2stTel,
            driverDirect: true,

            birthday: formatBirthTime(Number(resInfo?.data.driver2stBirthday)),
            licenseNum: resInfo?.data.driver2stLicenseNum || "",
            licenseType: resInfo?.data.driver2stLicenseType,
            fileId: resInfo?.data.driver2stLicenseImage,
            licenseFileGroupId: resInfo?.data.driver2stFileGroupId,
            licenseCerti: true,
            needCheckCareer: [],
            memberRegFlag: optionalArgeeCheck || false
          })
          
          dispatch(driver(driverArr));
          
          // history.push("/addIns");
          history.push("/driverInfo");
        } else {
          //모바일 체크인을 하고 온 경우, 면허증 직원이 확인 필요(driverDirect)
          dispatch(driver(driverArr));
          history.push("/driverInfo");
        }


        // //모바일 체크인시 부운전자 등록이 되어 있다면 Set
        // if (resInfo?.data.driver2stName) {
        //   driverArr.push({
        //     driverName: resInfo?.data.driver2stName,
        //     tel: resInfo?.data.driver2stTel,
        //     birthday: formatBirthTime(Number(resInfo?.data.driver2stBirthday)),
        //     licenseNum: resInfo?.data.driver2stLicenseNum,
        //     licenseType: resInfo?.data.driver2stLicenseType,
        //     fileId: resInfo?.data.driver2stLicenseImage,
        //     LicenseFileGroupId: resInfo?.data.driver2stFileGroupId,
        //     licenseCerti: true,
        //     driverDirect: true
        //   });
        // }
      } else {
        history.push("/driverInfo");
      }
    }
  };

  useEffect(() => {
    let newTotalAmt = 0;

    if (ins.length > 0) {
      newTotalAmt += ins.reduce((total, item) => total + item.chargeRequester, 0);

    }
    console.log(insSub)
    if (insSub.length > 0) {
      setAddInsSubAmt(insSub.reduce((total, item) => total + item.chargeRequester, 0))
      //newTotalAmt += insSub.reduce((total, item) => total + item.chargeRequester, 0);
    }

    if (data?.additionRestChargeInfoArray && data?.additionRestChargeInfoArray.length > 0) {
      setAddProductAmt(data?.additionRestChargeInfoArray.reduce((total, item) => total + item.chargeRequester, 0))
      //newTotalAmt += data?.additionRestChargeInfoArray.reduce((total, item) => total + item.chargeRequester, 0);
    }

    if (data?.feeFieldInput && data?.feeFieldInput > 0) {
      newTotalAmt += data?.feeFieldInput;
    }

    if (data?.feeExtendRequester && data?.feeExtendRequester) {
      newTotalAmt += data?.feeExtendRequester;
    }

    setTotalAmt(newTotalAmt);

  }, [ins, insSub, data]);
  return (
    <>
      <Header></Header>
      {modalShow && (
        <AlertModal
          onClose={() => {
            setModalShow(false);
          }}
          title={modalTitle}
          content={modalContent}
        ></AlertModal>
      )}

      <div className="res-wrap">
        <div className="res-title-wrap">
          <span>예약정보</span>
        </div>

        <div className="res-info-wrap">
          <div className="company-info-wrap">
            <span className="company-name">{data?.companyName}</span>
            <span className="res-dtm">
              {formatTime(data?.reservationDtm || 0)}
            </span>
          </div>

          <div className="car-info-wrap">
            <span className="car-name">{data?.modelName}</span>
          </div>

          <div className="requseter-info-wrap">
            <span>
              {data?.req1stUserName}({data?.req1stUserTel})
            </span>
            {data?.feeFieldInput != null && data?.feeFieldInput > 0 && (
              <div><span className="fee-input-label">대여료 미납금 : </span> <span className="fee-input-price">{formatNumber(data?.feeFieldInput || 0)}원</span></div>
            )
            }
            {data?.feeExtendRequester != null && data?.feeExtendRequester > 0 && (
              <div><span className="fee-input-label">연장료 미납금 : </span> <span className="fee-input-price">{formatNumber(data?.feeExtendRequester || 0)}원</span></div>
            )
            }
          </div>

          <div className="take-return-wrap">
            <div className="take-wrap">
              <span className="take-dec">대여일시</span>
              <span className="take-dtm">
                {formatTime(data?.takeoverDtm || 0)}
              </span>
            </div>

            <div className="total-dtm-wrap">
              <span>{calculateTimeDifference(data?.takeoverDtm || 0, data?.returnDtm || 0)}</span>
            </div>

            <div className="take-wrap">
              <span className="take-dec">반납일시</span>
              <span className="take-dtm">
                {formatTime(data?.returnDtm || 0)}
              </span>
            </div>
          </div>

          <div className="insurance-wrap">
            <div className="insurance-info">
              <div className="insurance-row">
                <div className="insurance-name">보험명</div>
                <div
                  style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
                >
                  {/* {ins.length > 1
                    
                    ? `${ins[0].insuranceName} 외 ${String(ins.length - 1)}건`
                    : ins[0].insuranceName} */}
                  {ins.length > 0 && ins[0].insuranceName || '보험 없음'}
                </div>
                <div
                  style={{ width: "12%" }}
                  className="insurance-detail"
                  onClick={() => {
                    detailModal(ins[0]);
                  }}
                >
                  <span className="">상세보기</span>
                  <img src="/img/icon-right.svg" alt="Right Icon" />
                </div>
                <div style={{ width: "20%" }}>
                  {formatNumber(
                    ins.reduce((total, item) => total + item.chargeRequester, 0)
                  )}
                  원
                </div>
              </div>
            </div>
            <div className="insurance-info">
              <div className="insurance-row">
                <div className="insurance-name">특약명</div>
                <div
                  style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
                >
                  {insSub.length > 1 &&
                    `${insSub[0].insuranceName} 외 ${String(
                      insSub.length - 1
                    )}건`}
                  {insSub.length === 1 ? insSub[0].insuranceName : ""}
                  {insSub.length === 0 ? "없음" : ""}
                </div>
                {insSub.length >= 1 && (
                  <div
                    style={{ width: "12%" }}
                    className="insurance-detail"
                    onClick={() => {
                      detailModal(insSub[0]);
                    }}
                  >
                    <span className="">상세보기</span>
                    <img src="/img/icon-right.svg" alt="Right Icon" />
                  </div>
                )}
                {insSub.length >= 1 && (
                  <div style={{ width: "20%" }}>

                    {formatNumber(
                      insSub.reduce(
                        (total, item) => total + item.chargeRequester,
                        0
                      )
                    )}
                    원
                  </div>
                )}
              </div>
            </div>

            <div className="insurance-info">
              <div className="insurance-row">
                <div className="insurance-name">기타상품</div>
                <div
                  style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
                >
                  {(data?.additionRestChargeInfoArray &&
                    (data?.additionRestChargeInfoArray.length > 1
                      ? `${data?.additionRestChargeInfoArray[0]?.restChargeInfo
                        ?.productName
                      } 외 ${String(
                        data?.additionRestChargeInfoArray.length - 1
                      )}건`
                      : data?.additionRestChargeInfoArray[0]?.restChargeInfo
                        ?.productName)) ||
                    "없음"}
                </div>

                {data?.additionRestChargeInfoArray &&
                  data?.additionRestChargeInfoArray.length >= 1 && (
                    <div
                      style={{ width: "12%" }}
                      className="insurance-detail"
                      onClick={() => {
                        productDetail(data?.additionRestChargeInfoArray);
                      }}
                    >
                      <span className="">상세보기</span>
                      <img src="/img/icon-right.svg" alt="Right Icon" />
                    </div>
                  )}

                {data?.additionRestChargeInfoArray &&
                  data?.additionRestChargeInfoArray.length >= 1 && (
                    <div style={{ width: "20%" }}>
                      {formatNumber(
                        data?.additionRestChargeInfoArray.reduce(
                          (total, item) => total + item.chargeRequester,
                          0
                        )
                      )}
                      원
                    </div>
                  )}
              </div>
            </div>

            <div className="price-wrap">
              <div className="total-price">
                <span className="total-label">총 금액</span>
                <span className="price">  {formatNumber(
                  (totalAmt + (addProductAmt + addInsSubAmt)))} 원</span>
              </div>
              <SvgIcon
                component={DoDisturbOnOutlinedIcon}
                color="disabled"
                style={{ fontSize: "2.5em" }}
              ></SvgIcon>
              <div className="total-price">
                <span className="total-label">선 납입금</span>
                <span className="price">
                  {formatNumber(
                    (data?.accountInRequester || 0) -
                    (data?.accountOutRequester || 0)
                  )}{" "}
                  원
                </span>
              </div>
              <SvgIcon
                component={PauseCircleOutlinedIcon}
                color="disabled"
                style={{ fontSize: "2.5em", transform: "rotate(90deg)" }}
              ></SvgIcon>
              <div className="total-price">
                <span className="total-label">현장 결제</span>
                <span className="price" style={{ color: "#3E83F1" }}>
                  {formatNumber(
                    (
                      (totalAmt + (addProductAmt + addInsSubAmt)) -
                      ((data?.accountInRequester || 0) - (data?.accountOutRequester || 0)) 
                    ) || 0
                  )}{" "}
                  원
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="res-title-wrap">
          <span>유의사항</span>
        </div>

        <div className={data?.memberRegYn === "Y" ? "res-dec-wrap-optional" : "res-dec-wrap"} >
          <span>
            • 예약 차량의 렌트업체명, 모델명, 출발/반납 시간, 보험명, 총 금결제
            금액을 확인하였습니다.
            <br /> • 위조 및 타인의 운전면허증(신분증 및 면허정보) 또는
            신용카드를사용하여 발생하는 모든 민/형사 상의 책임은 본인에게
            있습니다.
            <br /> • 손해면책제도를 포함해도 운전 경력(면허취득)이 기준보다 낮을
            경우 자차 보상처리가 되지 않습니다.
          </span>
          <div className="res-dec-chk-wrap">
            <Check
              value={""}
              label={
                "(필수) 차량 손해 면책 내용과 유의 사항을 모두 읽고 확인하였으며, 이에 동의합니다."
              }
              onChange={() => {
                setArgreeCheck(!argeeCheck);
              }}
            ></Check>
          </div>
          {data?.memberRegYn === "Y" && (
          <div className="res-dec-chk-wrap-optional">
            <Check
            value={""}
            label={
              "(선택) 렌트카 특가 이벤트, 다양한 고객 혜택 수신에 동의합니다.(수집항목 : 이름, 연락처)"
            }
            onChange={() => {
              setOptionalArgreeCheck(!optionalArgeeCheck);
            }}
            ></Check>
          </div>
          )}
        </div>

        <div className="btn-wrap" style={{ width: "100%" }}>
          <button
            onClick={() => {
              nextStep();
            }}
          >
            동의하고 다음 단계로
          </button>
        </div>
        {detailShow && (
          <InsuranceModal
            detail={insDetail && insDetail}
            onClose={() => {
              setDetailShow(false);
            }}
          ></InsuranceModal>
        )}
        {productDetailShow && (
          <ProductModal
            detail={prodDetail}
            onClose={() => {
              setProductDetailShow(false);
            }}
          ></ProductModal>
        )}


        {/* <InsuranceJoinModal show={insJoinShow} onClose={() => { setInsJoinShow(false) }} resInfo={data}></InsuranceJoinModal>

        <ConfirmModal
          isOpen={confirmInfo.isOpen}
          title={confirmInfo.title}
          message={
            confirmInfo.content
          }
          onCancel={() => {
            setConfirmInfo(prev => ({ ...prev, isOpen: false }))
            resInfo?.data.preRegStatus === "Y" ? history.push("/addIns") : history.push("/driverInfo")
          }}
          onConfirm={() => {
            setInsJoinShow(true)
            setConfirmInfo(prev => ({ ...prev, isOpen: false }))
          }}
          confirmMent={'가입하기'}
          cancelMent={'미가입'}
        ></ConfirmModal> */}
      </div >
    </>
  );
};

export default Reservation;
